export const FULL_TITLE = "Motor Full Insurance";
export const THIRD_PARTY_TITLE = "Third Party Insurance";

const products = {
  [FULL_TITLE]: "full-insurance",
  [THIRD_PARTY_TITLE]: "third-party",
};
const vehicleTypes = ["Car", "Dual Purpose", "Three Wheeler", "Motor Cycle", "Motor Coach"];
const nonblank = (value) => typeof value === "string" && value.trim().length > 0;

export const isMotorTitle = (title) => Object.prototype.hasOwnProperty.call(products, title);

export const blankMotorDetails = () => ({
  vehicle_type: "", purpose_of_use: "", make: "", model: "",
  has_registration_number: "", has_lease_loan_or_hire: "",
  estimated_market_value: "", fuel_type: "", year_of_manufacture: "",
  no_claims_bonus_years: "", registration_number: "", engine_number: "",
  chassis_number: "",
});

export const validMotorDetails = (title, details) => {
  if (!isMotorTitle(title) || !details) return false;
  if (!vehicleTypes.includes(details.vehicle_type) || !nonblank(details.make) || !nonblank(details.model)) return false;

  if (title === FULL_TITLE) {
    return ["Private", "Hiring", "Rent"].includes(details.purpose_of_use)
      && ["yes", "no"].includes(details.has_registration_number)
      && ["yes", "no"].includes(details.has_lease_loan_or_hire)
      && nonblank(details.estimated_market_value)
      && Number.isFinite(Number(details.estimated_market_value))
      && Number(details.estimated_market_value) > 0
      && ["Petrol", "Diesel", "Hybrid", "Electric", "Other"].includes(details.fuel_type)
      && /^\d{4}$/.test(details.year_of_manufacture)
      && Number(details.year_of_manufacture) >= 1900
      && Number(details.year_of_manufacture) <= new Date().getFullYear() + 1
      && /^(?:[0-9]|10)$/.test(details.no_claims_bonus_years);
  }

  return ["Private", "Hiring"].includes(details.purpose_of_use)
    && [details.registration_number, details.engine_number, details.chassis_number].every(nonblank);
};

export const makeMotorLead = (title, user, details) => {
  if (!validMotorDetails(title, details)) throw new Error("Invalid motor inquiry");
  const email_body_json = {
    vehicle_type: details.vehicle_type,
    purpose_of_use: details.purpose_of_use,
    vehicle_make: details.make.trim(),
    vehicle_model: details.model.trim(),
  };

  if (title === FULL_TITLE) {
    Object.assign(email_body_json, {
      has_registration_number: details.has_registration_number === "yes",
      has_lease_loan_or_hire: details.has_lease_loan_or_hire === "yes",
      estimated_market_value: Number(details.estimated_market_value),
      fuel_type: details.fuel_type,
      year_of_manufacture: Number(details.year_of_manufacture),
      no_claims_bonus_years: Number(details.no_claims_bonus_years),
    });
  } else {
    Object.assign(email_body_json, {
      registration_number: details.registration_number.trim(),
      engine_number: details.engine_number.trim(),
      chassis_number: details.chassis_number.trim(),
    });
  }

  return {
    name: user.name.trim(), email: user.email.trim(), phone: user.phone.trim(),
    media_code: user.media_code,
    type: "Motor Insurance", product_type: products[title],
    main_category: "Motor", sub_category: details.vehicle_type,
    email_body_json,
  };
};
